import React from 'react';
import { FormMode } from '../../organisms/form/types';
import Divider from '../../../../../components/settings/components/my-profile/components/change-email-modal/change-email-modal-flow/sub-components/divider';

export default function ProspectLabelField({ index, formMode }) {
  return (
    <>
      {index === 0 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <span>Contact Information</span>
        </div>
      )}
      {index === 6 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Work Information</span>
        </div>
      )}
      {index === 16 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Social Profiles</span>
        </div>
      )}
      {index === 21 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Location Information</span>
        </div>
      )}
      {index === 24 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Company Information</span>
        </div>
      )}
      {index === 35 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Company Funding Info</span>
        </div>
      )}
      {index === 37 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Deal Information</span>
        </div>
      )}
      {formMode === FormMode.Add && index === 39 && (
        <div className="prospect-label-field bs-input-container input-default-container">
          Custom Fields
        </div>
      )}
      {formMode === FormMode.Edit && index === 39 && (
        <div className="prospect-label-field bs-input-container input-default-container prospect-fields">
          <Divider />
          <span>Custom Fields</span>
        </div>
      )}
    </>
  );
}
